import React, { useState, useEffect } from "react";
import LabelValueRow from "../../LabelValueRow";
import LabelLabelRow from "../../LabelLabelRow";

// MINIMALI / MASSIMALI
const MinimaliMassimaliWidget = ({
  fatturato,
  setContributiTotali,
  contributiTotali,
  riduzioneContributi,
  redditoPrevidenziale,
  isFullTime,
  parameters,
}) => {
  const [factors] = useState({
    reddito_imponibile_minimale: 16243,
    contributi_massimali: 105014,
    coeff_riduzione_contributi: riduzioneContributi === "1" ? 0.65 : 1,
    pivot_reddito_imponibile: 48279,
    contributi_minimali:
      parameters.gestionePrevidenziale === "0" ||
      parameters.gestionePrevidenziale === "5"
        ? 3898.32
        : 3976.29,
    maternita: 7.44,
    aliquota:
      parameters.gestionePrevidenziale === "0" ||
      parameters.gestionePrevidenziale === "5"
        ? riduzioneContributi === "1"
          ? 0.156
          : 0.24
        : riduzioneContributi === "1"
        ? 0.15912
        : 0.2448,
    aliquota_massima:
      parameters.gestionePrevidenziale === "0" ||
      parameters.gestionePrevidenziale === "5"
        ? riduzioneContributi === "1"
          ? 0.16562
          : 0.25
        : riduzioneContributi === "1"
        ? 0.16562
        : 0.2548,
    eccezioneINPS: parameters.eccezioneINPS,
  });

  const [fissi, setFissi] = useState(0);
  const [percentuali, setPercentuali] = useState(0);

  useEffect(() => {
    if (isFullTime === "0" && parameters.eccezioneINPS === "0") {
      if (redditoPrevidenziale < factors.reddito_imponibile_minimale) {
        setFissi(
          factors.contributi_minimali * factors.coeff_riduzione_contributi +
            factors.maternita
        );
        setPercentuali(0);
      } else {
        if (redditoPrevidenziale < factors.pivot_reddito_imponibile) {
          let rimanenza =
            redditoPrevidenziale - factors.reddito_imponibile_minimale;
          setFissi(
            factors.contributi_minimali * factors.coeff_riduzione_contributi +
              factors.maternita
          );
          setPercentuali(rimanenza * factors.aliquota);
        } else {
          if (redditoPrevidenziale < factors.contributi_massimali) {
            setFissi(
              factors.contributi_minimali * factors.coeff_riduzione_contributi +
                factors.maternita
            );
            setPercentuali(
              factors.pivot_reddito_imponibile * factors.aliquota +
                (redditoPrevidenziale - factors.pivot_reddito_imponibile) *
                  factors.aliquota_massima -
                factors.contributi_minimali *
                  factors.coeff_riduzione_contributi +
                factors.maternita
            );
          } else {
            setFissi(
              factors.contributi_minimali * factors.coeff_riduzione_contributi +
                factors.maternita
            );
            setPercentuali(
              factors.pivot_reddito_imponibile * factors.aliquota +
                (factors.contributi_massimali -
                  factors.pivot_reddito_imponibile) *
                  factors.aliquota_massima -
                factors.contributi_minimali *
                  factors.coeff_riduzione_contributi +
                factors.maternita
            );
          }
        }
      }
    } else if (isFullTime === "0" && parameters.eccezioneINPS === "1") {
      setFissi(0);
      setPercentuali(redditoPrevidenziale * factors.aliquota);
    } else {
      setFissi(0);
      setPercentuali(0);
    }
    setContributiTotali(fissi + percentuali);
  }, [
    redditoPrevidenziale,
    parameters.eccezioneINPS,
    factors.reddito_imponibile_minimale,
    factors.contributi_minimali,
    factors.contributi_massimali,
    factors.coeff_riduzione_contributi,
    factors.pivot_reddito_imponibile,
    factors.aliquota,
    factors.aliquota_massima,
    factors.maternita,
    riduzioneContributi,
    setFissi,
    fissi,
    setPercentuali,
    percentuali,
    fatturato,
    setContributiTotali,
    isFullTime,
  ]);

  return (
    <>
      {isFullTime === "0" && parameters.eccezioneINPS === "1" && (
        <div className="flex flex-row justify-between items-center bg-gray-100 px-4 mb-4 pb-2 pt-2 dark:bg-gray-600 w-full">
          <div className="flex flex-col ">
            <span className="text-gray-400">Eccezione INPS Commercianti</span>
            <div className="text-sm leading-[1.2] dark:text-gray-400">
              In questo regime contributivo, i contributi fissi{" "}
              <span className="font-bold">non sono dovuti.</span>
              <br />
              {parameters.riduzioneContributi === "1"
                ? "Hai deciso di applicare la riduzione dei contributi al 15,91%"
                : "Hai deciso di NON applicare la riduzione dei contributi, pagherai quindi il 24,48% del tuo Reddito Previdenziale"}
            </div>
          </div>
        </div>
      )}
      {isFullTime === "1" && (
        <div className="flex flex-row justify-between items-center bg-gray-100 px-4 mb-4 pb-2 pt-2 dark:bg-gray-600 w-full">
          <div className="flex flex-col ">
            <span className="text-gray-400">Esonero contributivo</span>
            <div className="text-sm leading-[1.2] dark:text-gray-400">
              Avendo già una posizione previdenziale attiva con il tuo lavoro
              dipendente full-time sei esonerato dal pagare altri contributi
            </div>
          </div>
        </div>
      )}

      {factors.eccezioneINPS === "0" ? (
        <LabelValueRow label={"Fissi"} value={fissi} />
      ) : (
        <LabelLabelRow label={"Fissi"} value={"Non dovuti"} />
      )}

      <LabelValueRow label={"Percentuali"} value={percentuali} />
      <LabelValueRow
        label={"Contributi totali"}
        value={contributiTotali}
        important={true}
      />
    </>
  );
};

export default MinimaliMassimaliWidget;
